export default __webpack_public_path__ + "static/media/profile.2e21b499.svg";